import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useQueryWithStore } from 'react-admin';
import { get } from 'lodash';

import { Dimensions, Weight } from 'icons';
import { isImperialUnitMeasurement } from 'services/helpers/unitsMeasurement';
import { convertOzToLbOz, convertGmToKgGm } from 'services/helpers/convertWeight';

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: 'bottom',
    color: theme.palette.primary.light,
    marginRight: theme.spacing(1),
  },

  params: {
    fontSize: 14,
    lineHeight: '24px',
    color: theme.palette.text.secondary,
  },
}));

interface Props {
  record: Rollo.PackageInfoDTO;
}

const PackageField = ({ record }: Props) => {
  const classes = useStyles();

  const isImperial = isImperialUnitMeasurement();

  const { data: packageTypes } = useQueryWithStore({
    type: 'getList',
    resource: 'packageTypesFull',
  });

  const packageType =
    packageTypes?.find((item) => item.code === record?.type)?.label ?? record?.type;

  const { weightLb, weightOz } = convertOzToLbOz(record?.weightOz ?? 0);
  const { weightKg, weightGm } = convertGmToKgGm(record?.weightGm ?? 0);

  return (
    <Grid container spacing={1} data-test="package">
      <Grid item xs={12}>
        <Typography>{packageType}</Typography>
      </Grid>
      <Grid item xs={6} className={classes.params} data-test="dimensions">
        <Dimensions className={classes.icon} />
        {get(record, 'size.length')}&times;{get(record, 'size.width')}&times;
        {get(record, 'size.height')}
        {isImperial ? 'in' : 'cm'}
      </Grid>
      <Grid item xs={6} className={classes.params} data-test="weight">
        <Weight className={classes.icon} />
        {isImperial ? `${weightLb} lb ${weightOz} oz` : `${weightKg} kg ${weightGm} g`}
      </Grid>
    </Grid>
  );
};

export default PackageField;
